export const reversePercent = (value?: number) => {
  return 100 - (value || 0);
};

export const WALLET_CURRENT_YEAR = new Date().getFullYear();
